import React from 'react';

import { Box } from '@mui/material';
import Moment from 'moment';
import { useTranslation } from 'react-i18next';

import { type ContentItem } from './types';

interface Props {
    item: ContentItem;
}

const Tab: React.FC<Props> = ({ item }) => {
    const { t } = useTranslation('portal');
    const { user_name: userName } = item.student!;

    return (
        <Box
            sx={{
                position: 'relative',
                fontSize: '12px',
                marginBottom: '6px',
                paddingTop: '6px',
                paddingBottom: '6px',
                width: '100%',
                border: '1px solid rgba(71,57,231,0.1)',
                borderRadius: '5px',
                padding: '3px',
                backgroundColor: '#EDECFD'
            }}
        >
            <div style={{ fontWeight: 'bold' }}>
                {userName} {t('launched-tab')} <a href={item.data.data?.url}>{item.data.title}</a>
            </div>
            <div style={{ position: 'absolute', top: '0px', right: '4px', fontSize: '10px' }}>
                {Moment(new Date(item.timestamp)).format('h:mm A')}
            </div>
        </Box>
    );
};

export default Tab;
